import type { AuthState } from '../Auth.types';

export const authInitialState: AuthState = {
  state: undefined,
  loading: false,
  isLoggingOut: false,
};
